import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export enum PollTimeLine {
  ONE_DAY = 'one_day',
  THREE_DAY = 'three_day',
   ONE_WEEK = 'one_week',
  TWO_WEEK = 'two_week',
 
}
@Component({
  selector: 'app-feed-form-poll-select-modal',
  templateUrl: './feed-form-poll-select-modal.component.html',
  styleUrls: ['./feed-form-poll-select-modal.component.scss']
})
export class FeedFormPollSelectModalComponent {
  showMoreOptions = false;
   @Input() pollData: any;
  pollForm!: FormGroup;
  modalRef: NgbModalRef;

  pollDurations = [
    { label: '1 Day', value: PollTimeLine.ONE_DAY },
    { label: '3 Days', value: PollTimeLine.THREE_DAY },
    { label: '1 Week', value: PollTimeLine.ONE_WEEK },
    { label: '2 Week', value: PollTimeLine.TWO_WEEK },
  
  ];

  constructor(private fb: FormBuilder, private modalService: NgbModal,) {}

  ngOnInit(): void {
    // this.pollForm = this.fb.group({
    //    question: ['', Validators.required],
    //    timeLine: [PollTimeLine.ONE_DAY],
    //   options: this.fb.array([
    //     this.fb.group({ value: ['', Validators.required] }),
    //     this.fb.group({ value: ['', Validators.required] })
    //   ]),
    // });

      this.pollForm = this.fb.group({
    question: [this.pollData?.question || '', Validators.required],
    timeLine: [this.pollData?.timeLine || PollTimeLine.ONE_DAY],
    options: this.fb.array([])
  });

  // If editing, pre-fill existing options
  if (this.pollData?.options?.length) {
    this.pollData.options.forEach((opt: any) => {
      this.optionControls.push(
        this.fb.group({
          value: [opt.optionText || '', Validators.required]
        })
      );
    });
  } else {
    // New poll → default two empty options
    this.optionControls.push(this.fb.group({ value: ['', Validators.required] }));
    this.optionControls.push(this.fb.group({ value: ['', Validators.required] }));
  }

  }

  get optionControls(): FormArray {
    return this.pollForm.get('options') as FormArray;
  }

  addOption(): void {
    if (this.optionControls.length <= 10) {
      this.optionControls.push(this.fb.group({ value: [''] }));
    }
  }

  removeOption(index: number): void {
    if (this.optionControls.length > 2) {
      this.optionControls.removeAt(index);
    }
  }
 

  onSubmit(): void {
  const formValue = this.pollForm.value;
  const formatted = {
    ...this.pollData,
    question: formValue.question,
    timeLine: formValue.timeLine,
    totalVotes: 0,
    options: formValue.options.filter((o: any) => o.value && o.value.trim() !== "")
    .map((o: any, idx: number) => ({
      id: Date.now() + idx,
      optionText: o.value,
      voteCount: 0,
      userVoted: false,
      votes: [],
      votePercentage: 0
    })),
  };

  this.modalRef.close({poll:formatted});
  console.log('Final JSON (create/edit):', formatted);
}

  onClose(){
     this.modalRef.close(null)
  }
}
